import { render } from "./sidebar.vue?vue&type=template&id=98caad28&scoped=true&ts=true"
import script from "./sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./sidebar.vue?vue&type=style&index=0&id=98caad28&scoped=true&lang=scss&module=true"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./sidebar.vue?vue&type=style&index=0&id=98caad28&scoped=true&lang=scss&module=true", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("98caad28")
  })
}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-98caad28"],['__file',"src/main/webapp/app/core/sidebar/sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "98caad28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('98caad28', __exports__)) {
    api.reload('98caad28', __exports__)
  }
  
  module.hot.accept("./sidebar.vue?vue&type=template&id=98caad28&scoped=true&ts=true", () => {
    api.rerender('98caad28', render)
  })

}


export default __exports__